@file:OptIn(InternalResourceApi::class)

package balloon_pop.composeapp.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.DrawableResource
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem

private const val MD: String = "composeResources/balloon_pop.composeapp.generated.resources/"

@delegate:ResourceContentHash(420_111_464)
internal val Res.drawable.bg_flowers: DrawableResource by lazy {
      DrawableResource("drawable:bg_flowers", setOf(
        ResourceItem(setOf(), "${MD}drawable/bg_flowers.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_252_175_171)
internal val Res.drawable.bg_lawn: DrawableResource by lazy {
      DrawableResource("drawable:bg_lawn", setOf(
        ResourceItem(setOf(), "${MD}drawable/bg_lawn.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-57_065_872)
internal val Res.drawable.bg_mountains: DrawableResource by lazy {
      DrawableResource("drawable:bg_mountains", setOf(
        ResourceItem(setOf(), "${MD}drawable/bg_mountains.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-2_110_735_757)
internal val Res.drawable.bg_rainbow: DrawableResource by lazy {
      DrawableResource("drawable:bg_rainbow", setOf(
        ResourceItem(setOf(), "${MD}drawable/bg_rainbow.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-623_328_957)
internal val Res.drawable.bg_sky: DrawableResource by lazy {
      DrawableResource("drawable:bg_sky", setOf(
        ResourceItem(setOf(), "${MD}drawable/bg_sky.xml", -1, -1),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainDrawable0Resources(map: MutableMap<String, DrawableResource>) {
  map.put("bg_flowers", Res.drawable.bg_flowers)
  map.put("bg_lawn", Res.drawable.bg_lawn)
  map.put("bg_mountains", Res.drawable.bg_mountains)
  map.put("bg_rainbow", Res.drawable.bg_rainbow)
  map.put("bg_sky", Res.drawable.bg_sky)
}
